import { css } from "@emotion/css";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { _Text } from "../../_assets/_Text";
import { sharedStyles } from "../styles";

interface Props extends PropsWithChildren {
  emptyMessage?: string;
  isEmpty?: boolean;
  className?: string;
}

export function _InputWrapper(props: Props) {
  const { className } = props;
  const { t } = useTranslation();

  const { emptyMessage = t("No results found"), isEmpty, children } = props;

  return (
    <div
      className={css(
        sharedStyles.input,
        styles.wrapper,
        isEmpty && { "> input": { display: "none" } },
        className
      )}
    >
      {children}
      {isEmpty && (
        <span className={css({ paddingLeft: "var(--space-3)" })}>
          <_Text
            style="input/text-field"
            color="text-weak"
            className={styles.helperText}
          >
            {emptyMessage}
          </_Text>
        </span>
      )}
    </div>
  );
}

const styles = {
  wrapper: css({
    display: "flex",
    flexDirection: "row",
    padding: 0,
    gap: "var(--space-1)",
    alignItems: "center",
    minHeight: 40,

    "> input": {
      flex: 1,
      boxShadow: "none",
      background: "none",
      width: "inherit",

      "&[data-hovered]": { boxShadow: "none" },
      "&[data-focused]": { boxShadow: "none" },
      "&[data-invalid]": {
        boxShadow: "none",
        "&[data-focused]": { boxShadow: "none" },
      },
      "&[data-disabled]": { boxShadow: "none", background: "none" },
    },

    "> *": {
      borderRadius: 0,
      paddingLeft: "var(--space-05)",
      paddingRight: "var(--space-05)",
      alignSelf: "stretch",
    },

    "> i, > span": {
      marginTop: "auto",
      marginBottom: "auto",
    },

    "> *:first-child": {
      paddingLeft: "var(--space-3)",
      borderTopLeftRadius: "var(--border-radius-2)",
      borderBottomLeftRadius: "var(--border-radius-2)",
    },

    "> *:last-child": {
      paddingRight: "var(--space-3)",
      borderTopRightRadius: "var(--border-radius-2)",
      borderBottomRightRadius: "var(--border-radius-2)",
    },

    "&:has(input[data-hovered])": {
      boxShadow: `inset 0 0 0 1px var(--border-input-hover)`,
    },
    "&:has(input[data-focused])": {
      boxShadow: "var(--focus-input)",
    },
    "&:has(input[data-invalid])": css({
      boxShadow: `inset 0 0 0 1px var(--border-danger-input)`,
      "&:has(input[data-focused])": {
        boxShadow: "var(--focus-input-error)",
      },
    }),
    "&:has(input[data-disabled]), &:has(input[aria-disabled])": {
      boxShadow: `inset 0 0 0 1px var(--border-input-disabled)`,
      backgroundColor: "var(--background-input-disabled)",
    },
  }),
  helperText: css({
    flex: 1,
    display: "flex",
    alignItems: "center",
    paddingLeft: "var(--space-3)",
  }),
};
